import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useShowAlerts = (): boolean => {
  const [searchParameters] = useSearchParams();

  return useMemo(() => {
    const value = searchParameters.get('showAlerts');

    return value === 'true';
  }, [searchParameters]);
};

export default useShowAlerts;
